import React, { useEffect, useState } from "react";
import Title from "../title";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaPlus } from "react-icons/fa";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";

const Contacts = ({
  handleChange,
  paymentMethod,
  setPaymentMethod,
  inputValue,
  setInputValue,
  formData,
  setFormData,
}) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const handleAddMethod = () => {
    if (selectedMethod && !paymentMethod.includes(selectedMethod)) {
      setPaymentMethod([...paymentMethod, selectedMethod]);
      setSelectedMethod("");
    }
  };

  const handleDeleteMethod = (index) => {
    setPaymentMethod(paymentMethod.filter((_, i) => i !== index));
  };
  useEffect(() => {
    const getPaymentMethods = async () => {
      const { response, message } = await Helper.Get({
        url: api_Routes.PaymentMethods.get,
        hasToken: true,
      });
      if (response) {
        const methodsArray = response.data.payment_methods.value.split(",");
        setPaymentMethods(methodsArray);
      }
      return response;
    };
    getPaymentMethods();
  }, []);
  return (
    <div className="contacts">
      <Title title="Contacts" />
      <div className="contacts-data-container">
        <TextField
          fullWidth
          variant="outlined"
          onChange={(e) => {
            handleChange("smmpanel_email", e.target.value);
          }}
          name="smmpanel_email"
          label="Panel Email"
          type="email"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_tel1"
          onChange={(e) => {
            handleChange("smmpanel_tel1", e.target.value);
          }}
          label="Phone number"
          size="small"
        />
        <TextField
          fullWidth
          onChange={(e) => {
            handleChange("smmpanel_skybe", e.target.value);
          }}
          variant="outlined"
          name="Address"
          label="Skype"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_instagram"
          onChange={(e) => {
            handleChange("smmpanel_instagram", e.target.value);
          }}
          label="Instagram"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          onChange={(e) => {
            handleChange("smmpanel_fb", e.target.value);
          }}
          name="smmpanel_fb"
          label="Facebook"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_telegram"
          onChange={(e) => {
            handleChange("smmpanel_telegram", e.target.value);
          }}
          label="Telegram"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_whatsapp"
          onChange={(e) => {
            if (
              /^\+?[0-9]*$/.test(e.target.value) &&
              e.target.value.length <= 13
            ) {
              handleChange("smmpanel_whatsapp", e.target.value);
            }
          }}
          value={formData?.smmpanel_whatsapp || ""}
          label="WhatsApp"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_twitter"
          onChange={(e) => {
            handleChange("smmpanel_twitter", e.target.value);
          }}
          label="Twitter"
          size="small"
        />
      </div>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{ position: "relative", marginTop: "20px" }}
      >
        <Typography
          sx={{
            marginBottom: "10px",
            fontWeight: "600",
            fontSize: "24px",
            lineHeight: "30px",
            color: "#474747",
          }}
        >
          Payment Methods
        </Typography>

        <FormControl
          fullWidth
          size="small"
          sx={{
            width: "100%",
            maxWidth: "400px", // Set maximum width
            boxShadow: "-2px 2px 4px #00000040",
            borderRadius: "10px",
            backgroundColor: "white",
            marginTop: "10px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              "&:hover fieldset": {
                borderColor: "black !important",
              },
              "&.Mui-focused fieldset": {
                borderColor: "black !important",
              },
            },
          }}
        >
          <Select
            multiple
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            displayEmpty
            inputProps={{
              "aria-label": "Select payment methods",
              style: {
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
            sx={{
              "& .MuiSelect-select": {
                padding: "8px",
                fontSize: "16px",
                whiteSpace: "nowrap", // Prevent wrapping
                overflow: "hidden",
                textOverflow: "ellipsis", // Add ellipsis for overflow
              },
            }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <Typography style={{ color: "#a0a0a0" }}>
                    Select Payment Methods
                  </Typography>
                );
              }
              // Truncate long lists
              const displayValues =
                selected.length > 2
                  ? `${selected.slice(0, 2).join(", ")} +${
                      selected.length - 2
                    } more`
                  : selected.join(", ");

              return (
                <Typography noWrap sx={{ maxWidth: "90%" }}>
                  {displayValues}
                </Typography>
              );
            }}
          >
            <MenuItem value="" disabled>
              <Typography>Select Payment Methods</Typography>
            </MenuItem>
            {paymentMethods.map((method) => (
              <MenuItem
                key={method}
                value={method}
                sx={{ whiteSpace: "normal" }}
              >
                <Checkbox checked={paymentMethod.indexOf(method) > -1} />
                {method}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </div>
  );
};

export default Contacts;
